import React from "react";
import { FaGithub } from "react-icons/fa";

function Projects({ setActiveSection }) {
  return (
    <section id="projects" className="flex justify-center items-center min-h-screen">
      <div className="w-full md:w-[800px]">
        <h1 className="text-4xl md:text-6xl font-bold mb-8 md:mb-10">
          Projects
        </h1>
        {/* Project 2 */}
        <div className="project-card mb-6 bg-white bg-opacity-100 p-8 rounded-lg shadow-lg w-full card">
          <h2 className="text-2xl md:text-4xl font-bold mb-2">
            Student Management System
          </h2>
          <p className="text-md md:text-lg text-white mb-4">
            A Complete Student management System using Java Spirng MVC, Spring JPA, Hibernate, MySQl, Lombok.
          </p>
          <div className="flex space-x-4">
            <a
              href="https://github.com/kaungSethLwin/Student-Management.git"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-blue-500 hover:text-blue-800"
            >
              <FaGithub className="text-xl mr-2" />
              View on GitHub
            </a>
            <a
              href="https://your-app-demo-link-for-project-2"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center demo-button animate-pulse"
            >
              Demo
            </a>
          </div>
        </div>
        {/* Project 3 */}
        <div className="project-card mb-6 bg-white bg-opacity-100 p-8 rounded-lg shadow-lg w-full card">
          <h2 className="text-2xl md:text-4xl font-bold mb-2">
            Quiz App
          </h2>
          <p className="text-md md:text-lg text-white mb-4">
            Quiz app using React and Open Trivia API
          </p>
          <div className="flex space-x-4">
            <a
              href="https://github.com/your-username/project-3"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-blue-500 hover:text-blue-800"
            >
              <FaGithub className="text-xl mr-2" />
              View on GitHub
            </a>
            <a
              href="https://your-app-demo-link-for-project-3"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center animate-pulse"
            >
              <button className="btn border-t-pink-700 ">Demo</button>
            </a>
          </div>
        </div>
         {/* Project 4 */}
         <div className="project-card mb-6 bg-white bg-opacity-100 p-8 rounded-lg shadow-lg w-full card">
          <h2 className="text-2xl md:text-4xl font-bold mb-2">
            Restaurant Management System GUI Stand Alone APP
          </h2>
          <p className="text-md md:text-lg text-white mb-4">
            A Real World Restaurant Management application Java Swing Application using java swing, lombok and mysql.
          </p>
          <div className="flex space-x-4">
            <a
              href="https://github.com/kaungSethLwin/Restaurantmanagementsystem.git"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-blue-500 hover:text-blue-800"
            >
              <FaGithub className="text-xl mr-2" />
              View on GitHub
            </a>
            <a
              href="https://drive.google.com/file/d/1jgWIPho2-0GThuFlTZvtD1NPXBwLz3GR/view?usp=drive_link"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center animate-pulse"
            >
              <button className="btn border-t-pink-700 ">Download</button>
            </a>
          </div>
        </div>
        {/* Go back to Home Page buttons */}
        <div className="mt-8 flex flex-col md:flex-row justify-between space-y-4 md:space-y-0 md:space-x-4">
          <button
            onClick={() => setActiveSection("about")}
            className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Go back to About Page
            <span className="ml-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 transform rotate-180"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </span>
          </button>
          <button
            onClick={() => setActiveSection("skills")}
            className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Go to Skills Page
            <span className="ml-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 transform"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}

export default Projects;
